import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export const ToasterLoadingIcon = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '0.75rem',
      height: '0.75rem',
    }}
  >
    <CircularProgress size="100%" />
  </div>
);
